export default {
  navTheme: "dark",
  primaryColor: "#2d6ac4",
  layout: "side",
  contentWidth: "Fluid",
  fixedHeader: false,
  autoHideHeader: false,
  fixSiderbar: false,
  colorWeak: false,
  menu: {
    locale: false,
  },
  title: "AUTOSLED",
  pwa: false,
  iconfontUrl: "",
};
